import React, { useState } from 'react'
import { User } from 'lucide-react'
import { Link } from 'react-router-dom'
import { useLocalStorage } from '../hooks/useLocalStorage'

interface ProfileAvatarProps {
  user: {
    id: string
    username: string
    isAdmin?: boolean
  }
  size?: 'sm' | 'md' | 'lg'
}

const ProfileAvatar: React.FC<ProfileAvatarProps> = ({ user, size = 'md' }) => {
  const [profileImage] = useLocalStorage<string | null>(`profileImage-${user.id}`, null)
  
  // Size classes
  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16'
  }
  
  const fontSizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-lg'
  }
  
  // If there's no profile image, show initials
  const getInitials = () => {
    return user.username.charAt(0).toUpperCase()
  }
  
  return (
    <Link 
      to="/portal/settings" 
      className={`relative rounded-full overflow-hidden flex items-center justify-center ${sizeClasses[size]} bg-[var(--color-secondary)] text-white hover:opacity-90 transition-opacity`}
      title={`${user.username}'s profile`}
    >
      {profileImage ? (
        <img 
          src={profileImage} 
          alt={user.username} 
          className="w-full h-full object-cover"
        />
      ) : (
        <span className={`font-semibold ${fontSizeClasses[size]}`}>
          {getInitials()}
        </span>
      )}
      
      {user.isAdmin && (
        <div className="absolute bottom-0 right-0 w-3 h-3 bg-[var(--color-primary)] border-2 border-white dark:border-dark-background rounded-full"></div>
      )}
    </Link>
  )
}

export default ProfileAvatar